import React from 'react';
import PropTypes from 'prop-types';
// Styles
import styles from './DownloadWrapper.module.scss';

const DownloadWrapper = ({ data }) => {
  return(
    <section className={`${styles.wrapper}`}>
      <div className={`wrapper ${styles.wrapper}`}>
          <div className={`primaryArea ${styles.primaryArea} ${data.primaryArea.textTheme === "light" ?styles.theme_light : styles.theme_dark}`}>
            <div className={`${styles.container}`}>
              <div className={`flex-row ${styles.noGutter}`}>
                  <div className="col-sm-12 col-lg-5 col-md-6">
                    <div className={`${styles.content}`}>
                      <div className="content">
                        <p className={`eyebrow ${styles.bodyCopy}`}>
                          {data.primaryArea.eyebrow}
                        </p>
                        <div className={`${styles.bodyCopyImg}`}>&nbsp;</div>
                        <h2 className={`heading-one ${styles["heading-one"]}`}>
                          {data.primaryArea.heading}
                        </h2>
                        <div className={`tiers ${styles.tiers}`}>
                          <p>{data.primaryArea.copy}</p>
                        </div>
                      </div>
                      <div className={`secondaryWrapper`}>
                        <div className={`download ${styles.download}`}>
                            <h3 className={`heading ${styles.heading}`}>
                              {data.primaryArea.downloadSection.heading}
                            </h3>
                            <p className={`copy-rights ${styles.copyRights}`}>{data.primaryArea.downloadSection.copy}</p>
                            <div className={`badges ${styles.badges}`}>                        {
                                data.primaryArea.downloadSection.apps.map((current, index) => (
                                  <div key={index} className={`badge ${styles.badge}`}>
                                    <a
                                      href={current.url}
                                      target="_blank"
                                      id={current.id}
                                      className={styles[current.icon]}
                                      rel="noopener noreferrer">
                                      <span>{current.altText}</span>
                                    </a>
                                  </div>
                                ))
                              }
                            </div>
                            <p className={`discalimer ${styles.disclaimer}`}>{data.primaryArea.downloadSection.disclaimer}</p>
                          </div>
                        </div>
                    </div>  
                  </div>
              </div>              
            </div>   
          </div>
      </div>
    </section>
  )
};

DownloadWrapper.propTypes = {
  data: PropTypes.object
};

DownloadWrapper.defaultProps = {
  data: {}
}

export default DownloadWrapper;
